import React from 'react';
import SectionTitle from './SectionTitle';
import AccessAccordion from './AccessAccordion';
import Typography from './StyledTypography';
import Link from './Link';
import trainIcon from '../../../../images/features/saga/train.png';
import busIcon from '../../../../images/features/saga/bus.png';
import carIcon from '../../../../images/features/saga/car.png';
import planeIcon from '../../../../images/features/saga/plane.png';
import makeStyles from '@material-ui/core/styles/makeStyles';
import SectionContainer from './SectionContainer';

const useStyles = makeStyles((theme) => ({
  gutterBottom: {
    marginBottom: theme.spacing(2),
  },
  bold: {
    fontWeight: 'bold',
  },
}));

const Accesses = () => {
  const classes = useStyles();
  return (
    <SectionContainer>
      <SectionTitle title="佐賀県へのアクセス" subtitle="ACCESS" />
      <AccessAccordion
        icon={trainIcon}
        title="鉄道利用の場合"
        details={
          <>
            <Typography>
              鉄道の場合は、博多駅から佐世保・ハウステンボス方面の特急や、九州新幹線で新鳥栖駅からの移動になります。唐津方面は、福岡から筑肥線を利用します。
            </Typography>
            <Typography>新大阪　→　新鳥栖駅　…　約2時間50分</Typography>
            <Typography>東　京　→　新鳥栖駅　…　約5時間15分</Typography>
            <Typography>
              名古屋　→　新鳥栖駅　…　約3時間45分 博多駅　→　佐賀駅　　…　約37分
            </Typography>
            <Typography>博多駅　→　唐津駅　　…　約80分</Typography>
            <Link href="https://www.jrkyushu.co.jp/railway/">
              JR九州案内センター
            </Link>
          </>
        }
      />
      <AccessAccordion
        icon={busIcon}
        title="バス利用の場合"
        details={
          <>
            <Typography>
              九州佐賀国際空港、福岡空港、博多駅から便利なバスが運行しています。
            </Typography>
            <Typography>九州佐賀国際空港　→　佐賀駅　…　約35分</Typography>
            <Typography>福岡空港　→　佐賀駅　…　約1時間15分</Typography>
            <Typography>
              福岡空港　→　唐津バスセンター（大手口）　…　約1時間55分
            </Typography>
            <Typography>福岡空港　→　伊万里駅前　…　約2時間20分</Typography>
            <Typography>福岡空港　→　嬉野インター　…　約1時間20分</Typography>
            <Typography className={classes.gutterBottom}>
              福岡空港　→　嬉野バスセンター　…　約1時間25分
            </Typography>
            <Typography>各バスの情報は以下よりご確認ください。</Typography>
            <Typography>
              <Link href="http://www.nishitetsu.ne.jp/kyushugo/reservation/">
                九州高速バス予約センター
              </Link>
            </Typography>
            <Typography>
              <Link href="https://www.jrkbus.co.jp/">JR九州バス</Link>
            </Typography>
            <Typography>
              <Link href="https://www.jrkbus.co.jp/rosen/ureshino-fudosan">
                JR九州バス（嬉野）
              </Link>
            </Typography>
            <Typography>
              <Link href="http://www.nishitetsu.ne.jp/kyushugo/route/">
                九州急行バス（福岡）
              </Link>
            </Typography>
            <Typography>
              <Link href="http://www.bus.saga.saga.jp/diagram/">
                佐賀市営バス
              </Link>
            </Typography>
            <Typography>
              <Link href="http://showa-bus.jp/">昭和バス（佐賀）</Link>
            </Typography>
            <Typography>
              <Link href="http://showa-bus.jp/">昭和バス（唐津）</Link>
            </Typography>
            <Typography>
              <Link href="https://www.yutoku.jp/">祐徳バス（鹿島）</Link>
            </Typography>
          </>
        }
      />
      <AccessAccordion
        icon={carIcon}
        title="車利用の場合"
        details={
          <>
            <Typography>
              佐賀県内の車での移動は、3つの有料道路を使うと便利です。
            </Typography>
            <Typography>【三瀬トンネル有料道路やまびこロード】</Typography>
            <Typography>
              福岡県福岡市早良区大字曲渕から佐賀県佐賀市三瀬村三瀬まで（一般国道263号）
            </Typography>
            <Typography>【厳木多久有料道路ひまわりロード】</Typography>
            <Typography>
              佐賀県唐津市厳木町中島から佐賀県多久市北多久町大字多久原まで（一般国道203号）
            </Typography>
            <Typography>
              0952-75-5511 【東脊振トンネル有料道路さざんかロード】
            </Typography>
            <Typography>
              佐賀県神埼郡吉野ヶ里町松隈～佐賀県神埼郡吉野ヶ里町松隈（一般国道385号）
            </Typography>
          </>
        }
      />
      <AccessAccordion
        icon={planeIcon}
        title="飛行機利用の場合"
        details={
          <>
            <Typography>
              佐賀空港へは東京便（羽田・成田）、上海便、台湾便が就航しています。また、近隣の福岡空港は関東・関西便が豊富にあります。
            </Typography>
            <Typography>
              ・東京［羽田空港］→　九州佐賀国際空港　…　約1時間50分
            </Typography>
            <Typography>
              ・千葉［成田国際空港］→　九州佐賀国際空港　…　約2時間
            </Typography>
            <Typography className={classes.gutterBottom}>
              <Link href="https://www.pref.saga.lg.jp/airport/list01000.html">
                各フライト状況はこちら
              </Link>
            </Typography>
            <Typography>
              なお、佐賀空港からの移動については以下が便利です。
            </Typography>
            <Typography className={classes.bold}>
              【佐賀空港リムジンタクシー】
            </Typography>
            <Typography>
              佐賀県内や福岡県南西部地域と空港とを直行で結ぶ、乗合タクシーです。
            </Typography>
            <Typography>
              利用希望日前日の17時までに予約をしていただければ、お一人様からでもご利用いただけます。ぜひ、便利でお得なリムジンタクシーをご利用ください。
            </Typography>
            <Link href="https://www.pref.saga.lg.jp/airport/kiji00312831/index.html">
              詳しくはこちら
            </Link>
            <Typography className={classes.bold}>【レンタカー】</Typography>
            <Typography>
              北部九州の中心！レンタカーを利用した九州周遊旅行の起点として便利です！
            </Typography>
            <Link href="https://www.pref.saga.lg.jp/airport/kiji00312799/index.html">
              詳しくはこちら
            </Link>
          </>
        }
      />
    </SectionContainer>
  );
};

export default Accesses;
